module.exports = __webpack_public_path__ + "static/case-1-65ea7f0ad23c9187288117d313d7b954.jpg";